import { t } from '@/i18n';
import { useClaimsStore } from '@/store/claims';
import { useProjectsStore } from '@/store/projects';
import Swal from 'sweetalert2';
import { useStoreApiAction } from './useStoreApiAction';

export function useRequestClaimApproval() {
  const claimsStore = useClaimsStore();
  const projectsStore = useProjectsStore();
  const requestApprovalAction = useStoreApiAction(claimsStore.requestApproval);

  const requestApproval = async (claimId: Id) => {
    const hasCompany = !!projectsStore.project?.company_id;

    const result = await Swal.fire({
      title: t('Claims.RequestApproval.title'),
      html: `
        <div class="text-left">
          <p class="mb-4">${
        hasCompany ? t('Claims.RequestApproval.textCompany') : t('Claims.RequestApproval.textEmailRequired')
      }</p>
        </div>
        <input
          id="request-approval-email"
          type="email"
          class="swal2-input"
          placeholder="${
        hasCompany ? t('Claims.RequestApproval.emailPlaceholderOptional') : t('Claims.RequestApproval.emailPlaceholder')
      }"
        />
      `,

      showCancelButton: true,
      confirmButtonText: t('Claims.RequestApproval.confirm'),
      cancelButtonText: t('Claims.RequestApproval.cancel'),
      confirmButtonColor: '#2563eb',
      cancelButtonColor: '#6b7280',
      preConfirm: () => {
        const emailInput = document.getElementById('request-approval-email') as HTMLInputElement;
        const email = emailInput?.value?.trim();

        if(!email && !hasCompany) {
          Swal.showValidationMessage(t('Claims.RequestApproval.emailRequired'));

          return false;
        }

        if(email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          Swal.showValidationMessage(t('Claims.RequestApproval.emailInvalid'));

          return false;
        }

        return email || undefined;
      },

      allowOutsideClick: false,
      allowEscapeKey: true,
    });

    if(!result.isConfirmed) {
      return;
    }

    const email = result.value;

    try {
      await requestApprovalAction.request(claimId, typeof email === 'string' ? { email } : {});

      await Swal.fire({
        icon: 'success',
        title: t('Claims.RequestApproval.successTitle'),
        text: t('Claims.RequestApproval.successText'),
      });
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: t('Claims.RequestApproval.failedTitle'),
        text: error?.data?.message ?? error?.data?.errors?.email?.[0],
      });
    }
  };

  return {
    requestApproval,
    requestApprovalAction,
  };
}
